import { Grid } from "@material-ui/core";
import DropdownFilter from "components/DropdownFilter";
import LotsDropdown from "components/SharedDropdowns/LotsDropDown";
import { useDispatch, useSelector } from "react-redux";
import { fieldTypes } from "services/filterService";
import { NewWashDashboardStyle } from "../NewWashDashboardStyle";
import { setLocationFilters } from "../washDashboardSlice";
import { useEffect } from "react";
import { isEqual } from "lodash";
import { withUserPreferences } from "components/UserPreferences/WithUserPreferences";
import { userPreferencesComponentIds, userPreferencesTypes } from "components/UserPreferences/userPreferencesConsts";

const DashboardFilters = ({ filterConfigs, filteredLots, refetch, saveFilters, savedFilters }) => {
    const classes = NewWashDashboardStyle();
    const dispatch = useDispatch();
    const { locationFilters } = useSelector(state => state.washDashboardState);

    const handleFilterChange = (key, value) => {
        let newFilters = { ...locationFilters, [key]: { value: value } };
        if (key === 'clientId') {
            newFilters['lotId'] = { value: [] };
        }
        dispatch(setLocationFilters(newFilters));
        saveFilters(newFilters);
    }

    useEffect(() => {
        if (savedFilters)
        {
            const mapped = { ...locationFilters };
            Object.entries(savedFilters).forEach(([k, v]) => {
                mapped[k] = { value: (v && typeof v === 'object' && Object.prototype.hasOwnProperty.call(v, 'value')) ? v.value : v };
            });
            if (!isEqual(mapped, locationFilters)) {
                dispatch(setLocationFilters(mapped));
            }
        }
    }, [savedFilters]);

    return (
        <Grid container spacing={1} alignItems="center">
            
            <Grid item xs={12} className={classes.filtersWrapper}>

                {filterConfigs?.map((filter, idx) =>
                    <Grid item xs={filter.size}
                        className={idx === filterConfigs.length - 1 ? classes.filterItemLast : classes.filterItem}
                        key={filter.key}>
                        {filter.type == fieldTypes.LOT ?
                                    <LotsDropdown
                                        clientId={locationFilters?.['clientId']?.value}
                                        title={filter.title}
                                        identifier={filter.key}
                                        values={filter.values}
                                        onSelect={(val) => handleFilterChange(filter.key, val)}
                                        value={Array.isArray(locationFilters?.[filter.key]?.value) ? locationFilters[filter.key].value : []}
                                        showEmpty={true}
                                        multiple={true}
                                        ownedByTenant={locationFilters?.['lotFilter']?.value == 'tenant'}
                                        filteredLots={locationFilters?.['lotFilter']?.value == 'washRule' ? filteredLots : null}
                                    // withTypeAhead={true}
                                    />
                                    :
                                    <DropdownFilter
                                        showEmpty={filter.showEmpty}
                                        title={filter.title}
                                        values={filter.values}
                                        value={filter.multiple ? (Array.isArray(locationFilters?.[filter.key]?.value) ? locationFilters[filter.key].value : []) : (locationFilters?.[filter.key]?.value ?? '')}
                                        onSelect={(val) => handleFilterChange(filter.key, filter.key == 'clientId' ? +val : val)}
                                        multiple={filter.multiple}
                                        withTypeAhead={filter.withTypeAhead}
                                        shrink
                                    />}
                    </Grid>
                )}

            </Grid>
        </Grid >
    );
}
export default withUserPreferences(DashboardFilters, userPreferencesComponentIds.WASH_DASHBOARD_PAGE, userPreferencesTypes.FILTERS);